module.exports = __webpack_public_path__ + "static/media/B&F Logo.3458a053.png";